import { Banner, PromptBanner, CreativityBanner } from './banner-interfaces';
import { CreativityType } from './creativity-interfaces';

export const isPromptBanner = (banner: Banner): banner is PromptBanner =>
  'prompt' in banner && typeof banner.prompt === 'string';

export const isCreativityBanner = <T extends CreativityType>(banner: Banner): banner is CreativityBanner<T> =>
  'creativityConfig' in banner && !('prompt' in banner);
